import { useContext } from "react";
import context, { IProjectTalentsSearchContext } from "../state/context";

export default (): IProjectTalentsSearchContext => useContext(context);
